import * as React from 'react';
import { getOrderCssClass } from '../../shared/Site';

interface SellerInvoicablesListRowProps {
    brokerFirmName: string;
    invoiceBillingMethod: string;
    orderCount: number;
    key: number;
    showInvoice: () => void;
    site: number;
    checked: boolean;
    onCheckboxChange: () => void;
}

class SellerInvoicablesListRow extends React.Component<SellerInvoicablesListRowProps, any> {
    constructor(props: SellerInvoicablesListRowProps, context: any) {
        super(props, context);
    }

    render() {
        return (
            <tr
                onClick={() => this.props.showInvoice()}
                className={getOrderCssClass(this.props.site)}               
            >
                <td>
                    <input
                        type="checkbox"
                        checked={this.props.checked}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                            e.stopPropagation();
                            this.props.onCheckboxChange();
                        }}
                    />
                </td>                
                <td>{this.props.brokerFirmName}</td>
                <td>{this.props.orderCount}</td>
                <td>{this.props.invoiceBillingMethod}</td>
                <td></td>
            </tr>
        );
    }
}

export default SellerInvoicablesListRow;
